// frontend/src/router.tsx
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import Login from './components/Login';
import Landing from './components/Landing';
import HowItWorks from './components/HowItWorks';
import Pricing from './components/Pricing';
import PrivacyPolicy from './components/PrivacyPolicy';
import Contact from './components/Contact';
import NotFound from './components/NotFound';
import SharedScenarioView from './components/SharedScenarioView';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ConfigProvider } from './context/ConfigContext';

// Component that handles the root route logic
const RootRoute: React.FC = () => {
  const { currentUser, impersonatingUid } = useAuth();

  // If authenticated, show the app
  if (currentUser) {
    return <App key={impersonatingUid || 'self'} />;
  }

  // If not authenticated, show landing page
  return <Landing />;
};

const ConfigProviderWithKey: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const { impersonatingUid } = useAuth();
  return <ConfigProvider key={impersonatingUid || 'self'}>{children}</ConfigProvider>;
};

const Router: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ConfigProviderWithKey>
          <ErrorBoundary>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<RootRoute />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/s/:shareCode" element={<SharedScenarioView />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </ErrorBoundary>
        </ConfigProviderWithKey>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Router;
